import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Text } from 'atoms';
import { useAuth } from 'hooks';
import { ColorRound } from 'components';
import { SalesMenList, SalesMenFilter, Header } from 'components/pages/collection-app/sales-men';
import { AR } from 'utils/constants';
import {
	getSalesMen,
	setAdditionalFilter,
	setChosenColor,
	setInvoiceSearch,
	setIsNoInvoicesMen,
	singleStatusFilter,
} from 'store/salesmanSlice';

const colorsLegend = [
	{ color_id: 1, color: 'blue', label: 'Received Runsheet' },
	{ color_id: 2, color: 'orange', label: 'Partially Completed by Sales Person' },
	{ color_id: 3, color: 'green', label: 'Completed by Salesman' },
	{
		color_id: 4,
		color: 'red-border',
		label: 'Partially Completed by Additional Resource',
	},
	{ color_id: 5, color: 'red', label: 'Completed by Additional Resource' },
];

export default function SalesamanList() {
	const history = useHistory();
	const userInfo = useAuth();
	const dispatch = useDispatch();
	const { isNoInvoicesMen, additionalFilter, chosenColor } = useSelector(
		(state) => state.salesman
	);

	useEffect(() => {
		// on sales men list page clear already searched details
		dispatch(setInvoiceSearch(''));

		return () => {
			dispatch(setChosenColor(''));
		};
	}, [dispatch]);

	const handleColor = (id, color) => {
		if (additionalFilter) {
			dispatch(setAdditionalFilter(false));
		}
		if (isNoInvoicesMen) {
			dispatch(setIsNoInvoicesMen(false));
		}
		if (color === chosenColor) {
			dispatch(setChosenColor(''));
			dispatch(getSalesMen(true));
		} else {
			dispatch(setChosenColor(color));
			dispatch(singleStatusFilter(id));
		}
	};

	if (userInfo?.type !== AR) {
		history.goBack();
	} else {
		return (
			<>
				<Header />
				<Flex px="10px" flexDirection="column" alignItems="center">
					<Flex justifyContent="space-around" width="100%" my="1rem">
						{colorsLegend.map((item) => (
							<Flex
								cursor="pointer"
								flexDirection="column"
								alignItems="center"
								key={item.color_id}
								onClick={() => handleColor(item.color_id, item.color)}
							>
								<ColorRound
									color={item.color}
									chosenColor={item.color === chosenColor ? chosenColor : ''}
								/>
								<Text
									fontSize="10px"
									fontWeight={`${chosenColor === item.color ? 600 : 300}`}
									maxWidth="70px"
									textAlign="center"
									lineHeight="14px"
								>
									{item.label}
								</Text>
							</Flex>
						))}
					</Flex>
					<SalesMenFilter />
					<SalesMenList />
				</Flex>
			</>
		);
	}
}
